<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="delayTypeAudits && delayTypeAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="delayTypeAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Delay Type audits </ng-template>
</ng-template>
